// Include vendor styles
import './vendors/_bootstrap.scss';
import './vendors/_react-burger-menu.scss';
import './vendors/_flag_icons.scss';
import './vendors/_tg-modal.scss';
